import React, { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import LogoStack from 'design-system/LogoStack';
import { CardView } from 'design-system/CardView';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { useAppSelector } from 'store/hooks';
import { selectMaximumInterest } from 'features/pots/reducers/selectors';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../../../../constants';
const logos = ['🏡', '🏖️', '💻', '🎁'];
const StartSavingCard = memo(() => {
    const { navigateToTab } = useTabNavigation();
    const maximumInterest = useAppSelector(selectMaximumInterest);
    const handleNavigation = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://save?tab=pots', 'Create a Pot');
            return;
        }
        navigateToTab('Save', { tab: 'pots' });
    }, []);
    return (<CardView noMarginTop style={styles.container}>
      <LogoStack logos={logos}/>
      <Spacer.H16 />
      <Text Text-16 centered>
        {'Earn up to '}
        <Text Numbers-16 Secondary>
          {maximumInterest}
        </Text>
        % AER on your savings,{'\xa0'}FSCS{'\xa0'}protected
      </Text>
      <Spacer h={4}/>
      <Text TextThin-14 centered Secondary>
        Open a pot and start earning interest!
      </Text>
      <Spacer.H16 />
      <Button hug small brandReversed title="Create a Pot" onPress={handleNavigation}/>
    </CardView>);
});
export default StartSavingCard;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        paddingVertical: rem(24),
        paddingHorizontal: rem(32),
    },
});
